import React from 'react';

const PageLoader = () => {
  return (
    <div className="page-loader">
      <div className="loader-circle-container">
        <span className="loader-symbol">ॐ</span>
      </div>
    </div>
  );
};

export default PageLoader; 